import { useWriteContract } from 'wagmi'

import wrappedEthAbi from '@src/contract/abi/wrappedEth.abi.json'
import { useWaitForTransaction } from '@src/hooks/useWaitForTransaction'

export const useDepositWeth = () => {
    const { writeContractAsync } = useWriteContract()
    const { waitForTransactionReceipt } = useWaitForTransaction()

    const depositWeth = async (address?: string, amount?: bigint) => {
        if (!address || !amount) {
            throw new Error('Address and amount are required')
        }

        return await writeContractAsync({
            abi: wrappedEthAbi,
            address: address as `0x${string}`,
            functionName: 'deposit',
            value: BigInt(amount.toString()),
        })
    }

    const waitForDeposit = async (hash: string) => {
        await waitForTransactionReceipt(hash, false, false)
    }

    return {
        depositWeth,
        waitForDeposit,
    }
}
